
import React, { useState } from 'react'

import ADXImg from "../../assets/ADX1.jpg";



import Header from './Header';
import Footer from './Footer';
import SEO from '../SEO';

const Adx = () => {


    const [language, setLanguage] = useState("english"); // "english" or "hindi"

    return (

        <div className="w-screen h-full">
              {/* <SEO
                    title="Algo Controller Trading | Algo Controller"
                    description="Get real-time stock trading signals, live market updates, and PnL insights to make smarter trading decisions."
                    url="https://www.algocontroller.com/"
                    image="https://www.algocontroller.com/og-home.png"
                    header="Average Directional Index Indicator"
                  /> */}
            <Header></Header>
            <div className="bg-white/10 backdrop-blur-md m-3 rounded-lg ">
                <div className="  px-4 py-5 bg-white/20  ">
                    {/* Hero Image */}
                    <div className="rounded-xl flex justify-center   overflow-hidden shadow-lg">
                        <img
                            src={ADXImg}
                            alt="SMA Indicator"
                            className="object-cover h-72 w-full "
                        />
                    </div>

                    {/* Category Tag */}
                    <div className="mt-6">
                        <span className="inline-block bg-indigo-600 text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
                            Technical Indicator
                        </span>
                    </div>

                    <div className="w-full  rounded-md p-4 mt-2  flex flex-col items-center justify-between">




                        <h1 className="text-3xl sm:text-4xl font-bold text-black mt-4 leading-tight">
                            Understanding the Average Directional Index (ADX) Indicator
                        </h1>



                        <div className="flex flex-wrap m-4 gap-3">
                            <button
                                onClick={() => setLanguage("english")}
                                className={`p-2 font-bold rounded-md ${language === "english"
                                    ? "bg-blue-500 text-white"
                                    : "bg-blue-200 text-black"
                                    }`}
                            >
                                English
                            </button>

                            <button
                                onClick={() => setLanguage("hindi")}
                                className={`p-2 font-bold rounded-md ${language === "hindi"
                                    ? "bg-blue-500 text-white"
                                    : "bg-blue-200 text-black"
                                    }`}
                            >
                                हिन्दी
                            </button>
                        </div>


                        {language === "english" && (

                            <div>
                                <p className="mt-6 text-black leading-relaxed">
                                    The Average Directional Index (ADX) is a powerful technical indicator used to measure the strength of a trend. Unlike other indicators, ADX does not indicate the direction of the trend but quantifies how strong it is. Traders use ADX to identify trending or ranging markets, confirm trade signals, and avoid trading in weak trends. Whether you're new to technical analysis or an experienced trader, understanding ADX can help improve your timing and risk management in trading strategies.
                                </p>

                                <div className="w-full">
                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        How to Use ADX (Average Directional Index) in Trading
                                    </h2>

                                    <ol className="list-decimal ml-6 mt-4 space-y-4 text-black">
                                        <li>
                                            <strong>Open Your Trading Platform:</strong> Log in to your preferred platform (TradingView, Zerodha, Upstox, etc.).
                                        </li>

                                        <li>
                                            <strong>Select an Asset:</strong> Open the chart of the stock, crypto, or currency pair you want to analyze.
                                        </li>

                                        <li>
                                            <strong>Add ADX Indicator:</strong> Go to the <em>Indicators</em> menu and search for <em>ADX</em> or <em>Average Directional Index</em>. Add it to your chart.
                                        </li>

                                        <li>
                                            <strong>Understand the Components:</strong>
                                            <br />- ADX line → shows the strength of the trend.
                                            - +DI and −DI lines → indicate direction; +DI above −DI → uptrend, −DI above +DI → downtrend.
                                        </li>

                                        <li>
                                            <strong>Analyze Trend Strength:</strong>
                                            <br />- ADX below 25 → weak trend or sideways market.
                                            - ADX above 25 → strong trend.
                                            - Higher ADX values indicate a stronger trend.
                                        </li>

                                        <li>
                                            <strong>Combine with Other Indicators:</strong> Use ADX along with moving averages, RSI, MACD, or support/resistance levels to confirm trend strength and potential entry/exit points.
                                        </li>

                                        <li>
                                            <strong>Trading Tip:</strong> Avoid trading when ADX is below 25 (low trend strength) unless using a range-bound strategy.
                                        </li>
                                    </ol>

                                    <ul className="list-disc ml-6 mt-4 space-y-2 text-black">
                                        <li>
                                            <strong> Pros:</strong>
                                            <br />- Measures trend strength accurately.
                                            <br />- Helps filter out sideways or weak markets.
                                            <br />- Can be combined with +DI and -DI to confirm trend direction.
                                            <br />- Useful in trend-following strategies.
                                        </li>

                                        <li>
                                            <strong> Cons:</strong>
                                            <br />- Does not indicate trend direction alone.
                                            <br />- Can lag during trend reversals.
                                            <br />- Less useful in extremely volatile markets.
                                            <br />- Requires additional indicators for complete signals.
                                        </li>
                                    </ul>


                                    {/* What ADX Can Exactly Do */}
                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        What ADX Can Exactly Do
                                    </h2>

                                    <ol className="list-disc pl-5 space-y-2 text-black">
                                        <li>
                                            <strong>Measure Trend Strength:</strong> ADX shows how strong the current trend is, regardless of direction (up or down).
                                        </li>
                                        <li>
                                            <strong>Filter Weak or Sideways Markets:</strong> Helps avoid false signals by identifying low-strength or ranging markets.
                                        </li>
                                        <li>
                                            <strong>Identify Breakout Opportunities:</strong> Rising ADX can signal the start of a strong new trend.
                                        </li>
                                        <li>
                                            <strong>Support Trend-Following Strategies:</strong> Traders use ADX to confirm if trend-following systems (like moving averages) will be effective.
                                        </li>
                                        <li>
                                            <strong>Combine with +DI and -DI:</strong> ADX is often used with +DI and -DI lines to determine both trend strength and direction.
                                        </li>
                                        <li>
                                            <strong>Filter Market Noise:</strong> Helps focus on strong trends while ignoring minor price fluctuations.
                                        </li>
                                    </ol>

                                    {/* When to Use ADX Indicator */}
                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        When to Use ADX Indicator
                                    </h2>

                                    <ol className="list-disc pl-5 space-y-2 text-black">
                                        <li>
                                            <strong>Confirming Trend Strength:</strong> Use ADX to verify if a trend is strong enough to enter or hold a position.
                                        </li>
                                        <li>
                                            <strong>Avoiding Ranging Markets:</strong> Low ADX values (below 20) suggest weak or sideways markets—avoid trend trades here.
                                        </li>
                                        <li>
                                            <strong>Spotting Trend Beginnings:</strong> A rising ADX above 25 can signal a potential new trend forming.
                                        </li>
                                        <li>
                                            <strong>Enhancing Trend Systems:</strong> Use ADX to confirm signals from moving averages, RSI, or MACD before entering.
                                        </li>
                                        <li>
                                            <strong>Managing Risk:</strong> Strong ADX readings help traders decide when to use wider stop losses or scale positions.
                                        </li>
                                    </ol>
                                    <h2 className="text-2xl font-semibold text-black">
                                        📈 Generate ADX Signals Using Python
                                    </h2>

                                    <p className="mt-4 text-black leading-relaxed">
                                        You can fetch historical price data from <strong>Yahoo Finance</strong> and
                                        use <strong>TA-Lib</strong> to calculate the ADX (Average Directional Index), which measures trend strength. A simple strategy is:
                                    </p>

                                    <ul className="list-disc ml-6 mt-3 space-y-2 text-black">
                                        <li>
                                            ADX  25 → Strong trend → Follow the trend (buy in uptrend, sell in downtrend).
                                        </li>
                                        <li>
                                            ADX  20 → Weak trend → Market is range-bound → Avoid trend trading.
                                        </li>
                                        <li>
                                            Combine ADX with directional indicators (+DI and -DI) to confirm trend direction.
                                        </li>
                                    </ul>

                                </div>

                            </div>


                        )}

                        {language === "hindi" && (

                            <div>

                                <div>
                                    <p className="mt-6 text-black leading-relaxed">
                                        एवरेज डायरेक्शनल इंडेक्स (ADX) एक शक्तिशाली तकनीकी संकेतक है जो ट्रेंड की ताकत को मापने के लिए उपयोग किया जाता है। अन्य संकेतकों के विपरीत, ADX ट्रेंड की दिशा नहीं बताता, बल्कि यह मापता है कि ट्रेंड कितना मजबूत है। ट्रेडर्स ADX का उपयोग यह पता लगाने के लिए करते हैं कि बाजार ट्रेंडिंग है या साइडवेज़, ट्रेड सिग्नल की पुष्टि करने और कमजोर ट्रेंड में ट्रेडिंग से बचने के लिए। चाहे आप तकनीकी विश्लेषण में नए हों या अनुभवी ट्रेडर, ADX को समझना आपकी टाइमिंग और जोखिम प्रबंधन को बेहतर बना सकता है।
                                    </p>

                                    <div className="w-full">
                                        <h2 className="text-2xl font-semibold mt-10 text-black">
                                            ट्रेडिंग में ADX (एवरेज डायरेक्शनल इंडेक्स) का उपयोग कैसे करें
                                        </h2>

                                        <ol className="list-decimal ml-6 mt-4 space-y-4 text-black">
                                            <li>
                                                <strong>ट्रेडिंग प्लेटफॉर्म खोलें:</strong> अपने पसंदीदा प्लेटफॉर्म (TradingView, Zerodha, Upstox आदि) में लॉगिन करें।
                                            </li>

                                            <li>
                                                <strong>एसेट चुनें:</strong> उस स्टॉक, क्रिप्टो या करेंसी पेयर का चार्ट खोलें जिसे आप विश्लेषण करना चाहते हैं।
                                            </li>

                                            <li>
                                                <strong>ADX संकेतक जोड़ें:</strong> <em>Indicators</em> मेन्यू में जाएं और <em>ADX</em> या <em>Average Directional Index</em> खोजें और इसे अपने चार्ट में जोड़ें।
                                            </li>

                                            <li>
                                                <strong>इसके घटकों को समझें:</strong>
                                                <br />- ADX लाइन → ट्रेंड की ताकत दिखाती है।
                                                +DI और −DI लाइनें → दिशा दिखाती हैं; +DI &gt; −DI → अपट्रेंड, −DI &gt; +DI → डाउनट्रेंड।

                                            </li>

                                            <li>
                                                <strong>ट्रेंड की ताकत का विश्लेषण करें:</strong>
                                                <br />- ADX 25 से कम → कमजोर ट्रेंड या साइडवेज़ बाजार।
                                                - ADX 25 से ऊपर → मजबूत ट्रेंड।
                                                - ज्यादा ADX वैल्यू = ज्यादा मजबूत ट्रेंड।
                                            </li>

                                            <li>
                                                <strong>अन्य संकेतकों के साथ मिलाएं:</strong> ADX को मूविंग एवरेज, RSI, MACD या सपोर्ट/रेजिस्टेंस लेवल के साथ इस्तेमाल करें ताकि ट्रेंड की ताकत और एंट्री/एग्ज़िट पॉइंट्स की पुष्टि हो सके।
                                            </li>

                                            <li>
                                                <strong>ट्रेडिंग टिप:</strong> जब ADX 25 से कम हो (कमजोर ट्रेंड), तो ट्रेंड फॉलोइंग ट्रेड्स से बचें, जब तक कि आप रेंज-बाउंड रणनीति न अपना रहे हों।
                                            </li>
                                        </ol>

                                        <ul className="list-disc ml-6 mt-4 space-y-2 text-black">
                                            <li>
                                                <strong>फायदे (Pros):</strong>
                                                <br />- ट्रेंड की ताकत को सही तरीके से मापता है।
                                                <br />- साइडवेज़ या कमजोर बाजारों को फिल्टर करने में मदद करता है।
                                                <br />- ट्रेंड की दिशा की पुष्टि के लिए +DI और -DI के साथ मिलाकर उपयोग किया जा सकता है।
                                                <br />- ट्रेंड-फॉलोइंग रणनीतियों में उपयोगी।
                                            </li>

                                            <li>
                                                <strong>नुकसान (Cons):</strong>
                                                <br />- ट्रेंड की दिशा नहीं बताता।
                                                <br />- ट्रेंड बदलने पर लेग कर सकता है।
                                                <br />- अत्यधिक वोलाटाइल बाजारों में कम उपयोगी।
                                                <br />- पूर्ण सिग्नल के लिए अन्य संकेतकों की आवश्यकता होती है।
                                            </li>
                                        </ul>

                                        <h2 className="text-2xl font-semibold mt-10 text-black">
                                            ADX वास्तव में क्या कर सकता है
                                        </h2>

                                        <ol className="list-disc pl-5 space-y-2 text-black">
                                            <li>
                                                <strong>ट्रेंड की ताकत मापना:</strong> ADX दिखाता है कि मौजूदा ट्रेंड कितना मजबूत है, दिशा चाहे ऊपर हो या नीचे।
                                            </li>
                                            <li>
                                                <strong>कमजोर या साइडवेज़ बाजारों को फिल्टर करना:</strong> यह कमजोर ट्रेंड या रेंजिंग बाजारों की पहचान करके फॉल्स सिग्नल से बचने में मदद करता है।
                                            </li>
                                            <li>
                                                <strong>ब्रेकआउट अवसरों की पहचान:</strong> बढ़ता हुआ ADX नए मजबूत ट्रेंड की शुरुआत का संकेत दे सकता है।
                                            </li>
                                            <li>
                                                <strong>ट्रेंड-फॉलोइंग रणनीतियों का समर्थन:</strong> ट्रेडर्स ADX का उपयोग यह पुष्टि करने के लिए करते हैं कि ट्रेंड-फॉलोइंग सिस्टम (जैसे मूविंग एवरेज) प्रभावी होंगे या नहीं।
                                            </li>
                                            <li>
                                                <strong>+DI और -DI के साथ मिलाना:</strong> ADX अक्सर +DI और -DI के साथ इस्तेमाल किया जाता है ताकि ट्रेंड की ताकत और दिशा दोनों पता चल सके।
                                            </li>
                                            <li>
                                                <strong>बाजार शोर को फिल्टर करना:</strong> यह छोटे मूल्य उतार-चढ़ाव को नजरअंदाज करते हुए मजबूत ट्रेंड पर ध्यान केंद्रित करने में मदद करता है।
                                            </li>
                                        </ol>

                                        <h2 className="text-2xl font-semibold mt-10 text-black">
                                            ADX संकेत का उपयोग कब करें
                                        </h2>

                                        <ol className="list-disc pl-5 space-y-2 text-black">
                                            <li>
                                                <strong>ट्रेंड की ताकत की पुष्टि:</strong> ADX का उपयोग यह जांचने के लिए करें कि कोई ट्रेंड इतना मजबूत है कि उसमें एंट्री या होल्ड करना सुरक्षित हो।
                                            </li>
                                            <li>
                                                <strong>रेंजिंग बाजारों से बचाव:</strong> ADX 20 से कम होने पर बाजार कमजोर या साइडवेज़ होता है — ऐसे में ट्रेंड ट्रेड्स से बचें।
                                            </li>
                                            <li>
                                                <strong>नए ट्रेंड की शुरुआत पहचानना:</strong> ADX 25 से ऊपर बढ़ने पर नया ट्रेंड शुरू होने का संकेत मिल सकता है।
                                            </li>
                                            <li>
                                                <strong>ट्रेंड सिस्टम को मजबूत बनाना:</strong> मूविंग एवरेज, RSI या MACD से मिले सिग्नल की पुष्टि करने के लिए ADX का उपयोग करें।
                                            </li>
                                            <li>
                                                <strong>जोखिम प्रबंधन:</strong> मजबूत ADX रीडिंग यह तय करने में मदद करती है कि कब वाइडर स्टॉप लॉस या स्केल पोज़ीशन का उपयोग करें।
                                            </li>
                                        </ol>

                                        <h2 className="text-2xl font-semibold text-black">
                                            📈 Python का उपयोग करके ADX सिग्नल बनाएं
                                        </h2>

                                        <p className="mt-4 text-black leading-relaxed">
                                            आप <strong>Yahoo Finance</strong> से ऐतिहासिक मूल्य डेटा ला सकते हैं और
                                            <strong>TA-Lib</strong> का उपयोग करके ADX (Average Directional Index) की गणना कर सकते हैं, जो ट्रेंड की ताकत मापता है। एक सरल रणनीति यह है:
                                        </p>

                                        <ul className="list-disc ml-6 mt-3 space-y-2 text-black">
                                            <li>
                                                ADX 25 से ऊपर → मजबूत ट्रेंड → ट्रेंड फॉलो करें (अपट्रेंड में खरीदें, डाउनट्रेंड में बेचें)।
                                            </li>
                                            <li>
                                                ADX 20 से कम → कमजोर ट्रेंड → बाजार रेंज-बाउंड है → ट्रेंड ट्रेडिंग से बचें।
                                            </li>
                                            <li>
                                                ट्रेंड की दिशा की पुष्टि करने के लिए ADX को +DI और -DI संकेतकों के साथ मिलाएं।
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                        )}
                    </div>

                    {/* Intro Paragraph */}


                    {/* Getting Started Section */}


                </div>
                <div className="mt-6 w-full  p-4">


                    {/* <pre className="mt-6 bg-gray-900 text-green-300 p-4 rounded-lg overflow-x-auto text-sm"> */}
                    <pre className="mt-6 bg-gray-900 text-green-300 p-4 rounded-lg overflow-x-auto text-sm sm:text-xs md:text-sm">

                        <code>{`
import yfinance as yf
import pandas as pd
import talib

# Fetch historical data for NSE stock (e.g., Reliance)
ticker = "RELIANCE.NS"
data = yf.download(ticker, start="2024-08-01", end="2024-09-01", interval="1d")

# Calculate ADX, +DI, and -DI
data['ADX_14'] = talib.ADX(data['High'], data['Low'], data['Close'], timeperiod=14)
data['PLUS_DI_14'] = talib.PLUS_DI(data['High'], data['Low'], data['Close'], timeperiod=14)
data['MINUS_DI_14'] = talib.MINUS_DI(data['High'], data['Low'], data['Close'], timeperiod=14)

# Generate signals
data['Signal'] = None
for i in range(len(data)):
    if data['ADX_14'][i] > 25:
        if data['PLUS_DI_14'][i] > data['MINUS_DI_14'][i]:
            data.at[i, 'Signal'] = 'BUY'
        elif data['PLUS_DI_14'][i] < data['MINUS_DI_14'][i]:
            data.at[i, 'Signal'] = 'SELL'
    else:
        data.at[i, 'Signal'] = 'NO TREND'

print(data[['Close','ADX_14','PLUS_DI_14','MINUS_DI_14','Signal']].dropna())
`}</code>
                    </pre>

                    {/* Pros and Cons Section */}

                </div>



            </div>
            <Footer></Footer>
        </div>
    );


}

export default Adx